(function (root) {
  'use strict';
  const families = ['spartan ghost', 'shadow black', 'night shark', 'scorpion', 'valhalla', 'gladiator', 'shogun', 'phantom', 'vanquish', 'crusader', 'quantum', 'barbarian'];
  function prepare(product) {
    // Merchandising labels use product identity, never cross-series marketing copy.
    const identity = [product.title, product.productType, ...(product.tags || [])].join(' ').toLowerCase().replace(/[™®]/g, '');
    const series = families.find(name => identity.includes(name)) || product.handle || String(product.id);
    const statementModel = /\boverduty\b|obliterator|annihilator|devastator|punisher|bestiarius/.test(identity);
    const statementCollection = ['valhalla', 'shadow black', 'scorpion', 'spartan ghost'].includes(series);
    const styles = new Set(product.styles || [product.style]);
    if (statementCollection || statementModel) {
      styles.delete('classic'); styles.delete('unknown'); styles.add('bold');
    } else if (series === 'gladiator') {
      // A colored handle alone does not turn a standard Gladiator into a statement piece.
      styles.delete('bold'); styles.delete('unknown'); styles.add('classic');
    }
    const carvingSet = /\b(?:carving|slicing)\b.*\bset\b/i.test(product.title || '') || /\b(?:knife|knives)\s*(?:&|and)\s*fork\s+set\b/i.test(product.title || '');
    const isSet = Boolean(product.isSet || carvingSet);
    const style = styles.has(product.style) ? product.style : styles.values().next().value || 'unknown';
    const statementStrength = statementCollection || statementModel ? 2 : styles.has('bold') ? 1 : 0;
    return { ...product, series, statementStrength, styles: [...styles], style, isSet,
      length: isSet ? null : product.length,
      handling: isSet ? 'unknown' : product.handling,
      members: carvingSet ? [...new Set([...(product.members || []), 'slicer'])] : product.members
    };
  }
  if (typeof module !== 'undefined' && module.exports) module.exports = { prepare };
  else root.DalstrongKnifeFinderV2Profiles = { prepare };
})(typeof window !== 'undefined' ? window : globalThis);
